import { clone, cloneDeep } from "lodash";

export default {
  data() {
    return {
      formKey: 'self_form',
      specificationsValidResult: true,
      hasEditFlag: false,
      emitCount: 0,
    }
  },
  computed: {
    watchList: function() {
      const obj = {}
      const self_form = this[this.formKey];
      Object.keys(self_form).forEach(key => {
        obj[key] = self_form[key]
      })
      return obj
    },
  },
  watch: {
    watchList: {
      deep: true,
      handler: function(newVal,oldVal) {
        if (oldVal !== undefined) {
          this.$nextTick(() => {
            this.validPage();
            this.fixedPriceGet && this.fixedPriceGet();  // 淘宝规格列表价格变化，联通一口价实时校验
            this.checkHasEditFlag();
          });
        }
      },
      immediate: true
    },
  },
  methods: {
    // 抖音 hasEditFlag 
    checkHasEditFlag () {
      this.emitCount ++;
      if (this.emitCount > 1) {
        this.hasEditFlag = true;
      }
    },
    specificationsFieldChanged() {
      this.checkHasEditFlag();
      this.$nextTick(async () => {
        await this.valid_specifications();
        this.getErrorCount()
      });
    },
    async valid_specifications() {
      return new Promise(async (resolve, reject) => {
        const specificationsValid = this.validateSpecifications();
        this.specificationsValidResult = specificationsValid;
        if (specificationsValid !== true) {
          resolve(false);
          return;
        }
        resolve(true);
      });
    },
    async valid_form() {
      return new Promise(async (resolve) => {
        if (!this.$refs.form) {
          resolve(false);
          return false;
        }
        this.$refs.form.validate(valid => {
          resolve(valid);
        });
      });
    },
    async valid_cateprops() {
      return new Promise((resolve) => {
        const cateprops = this.$refs.cateprops;
        if (!cateprops || !cateprops.$refs.form) {
          resolve(true);
          return false;
        }
        cateprops.$refs.form.validate(valid => {
          resolve(valid);
        });
      });
    },
    async validPage() {
      let valid_others = [];
      if(this.valid_others) {
        valid_others.push(this.valid_others)
      }
      if(this.platform === 'fxg'){
        valid_others.push(this.validateDigitalID)
      }
      return new Promise(async (resolve) => {
        setTimeout(async () => {
          this.specificationsValidResult = true
          Promise.all([this.valid_specifications(), this.valid_form(), this.valid_cateprops(),...valid_others.map(fn => fn())]).then(async (validResult) => {
            const allValidIsTrue = validResult.every(item => item === true)
            if (allValidIsTrue) {
              this.$emit('form-validate-detail', [])
              resolve(true);
            } else {
              const errorDetails = await this.getErrorCount()
              resolve(errorDetails?.length === 0);
            }
          }).catch((error) => {
            resolve(false);
            this.getErrorCount()
          })
        }, 200);
      })
    },
    getErrorCount() {
      return new Promise(resolve => {
        setTimeout(() => {
          if (!this.$refs.form) {
            this.$emit('form-validate-detail', [])
            resolve([])
            return
          }
          const $el = this.$refs.form.$el
          const errorEls = [...$el.querySelectorAll('.el-form-item__error')]
          const details = []
          const seenProps = new Set()
          errorEls.forEach((el, index) => {
            // 参考 fixedToErrorWrap，向上手动遍历找 el-form-item（兼容嵌套场景）
            let formItem = null
            let cur = el
            while (cur && cur !== $el) {
              if (cur.tagName && cur.classList.contains('el-form-item')) {
                formItem = cur
                break
              }
              cur = cur.parentElement
            }
            if (!formItem) return

            // 获取 prop（仅用于展示，不再用于定位）
            let prop = ''
            const vueInstance = formItem.__vue__
            if (vueInstance && vueInstance.prop) {
              prop = vueInstance.prop
            }
            if (!prop) {
              prop = formItem.getAttribute('prop') || ''
            }

            // 向上遍历 el-form-item 直到找到有值的 label
            let label = ''
            let targetFormItem = formItem
            while (targetFormItem) {
              const labelEl = targetFormItem.querySelector('.el-form-item__label')
              const labelText = labelEl ? labelEl.textContent.replace(/[:：]/g, '').trim() : ''
              if (labelText) {
                label = labelText
                break
              }
              targetFormItem = targetFormItem.parentElement?.closest('.el-form-item')
            }
            if (!label) label = prop

            // 跳过 prop 为空的项（避免重复）
            if (seenProps.has(prop)) return
            seenProps.add(prop)

            // 记录 DOM 索引，用于后续滚动定位
            details.push({
              prop,
              label,
              message: el.textContent.trim(),
              errorIndex: index,
            })
          })
          this.$emit('form-validate-detail', details)
          resolve(details)
        }, 500)
      })
    },
    fixedToErrorWrap() {
      const $el = this.$refs.form.$el;
      const firstError = $el.querySelectorAll('.el-form-item__error')[0];
      if (firstError) {
        let parentElement = firstError;
        let currentElement = firstError;
        let tab_content = null;
        let target = $el;
        while(!tab_content) {
          if (target && target.className.split(' ').includes('el-tabs')) {
            tab_content = target;
          } else if (target.parentElement && target.parentElement.className.split(' ').includes('el-tabs__content')) {
            tab_content = target.parentElement;
          } else {
            target = target.parentElement;
          }
        }
        function offset(curEle, rootEl) {
          var totalTop = null,
            par = curEle.offsetParent;
          totalTop += curEle.offsetTop;
          while (par !== rootEl) {
            totalTop += par.offsetTop;
            par = par.offsetParent;
          }
          return totalTop;
        }
        tab_content.scrollTo(0, offset(parentElement ,tab_content) - 200);
      }
    },
  }
}